"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillSelect = void 0;
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const react_1 = __importDefault(require("react"));
const SkillSelect = (props) => {
    const options = [
        { label: (0, util_1.t)('SKILL_LETTER_1') + ': ' + (0, util_1.t)('SKILL_NAME_1'), value: 1 },
        { label: (0, util_1.t)('SKILL_LETTER_2') + ': ' + (0, util_1.t)('SKILL_NAME_2'), value: 2 },
        { label: (0, util_1.t)('SKILL_LETTER_3') + ': ' + (0, util_1.t)('SKILL_NAME_3'), value: 3 },
        { label: (0, util_1.t)('SKILL_LETTER_4') + ': ' + (0, util_1.t)('SKILL_NAME_4'), value: 4 },
        { label: (0, util_1.t)('SKILL_LETTER_5') + ': ' + (0, util_1.t)('SKILL_NAME_5'), value: 5 },
    ];
    if ((0, util_1.isUndefined)(props.includeAny) ? true : props.includeAny)
        options.unshift({ label: (0, util_1.t)('SKILL_ANY'), value: 'any' });
    const selectedOpt = options.find((o) => (o.value || 'any') === props.value);
    return (react_1.default.createElement(_ui_1.Dropdown, { label: props.label, sortedOptions: false, singleSelect: true, type: _ui_1.Dropdown.TYPES.VARIABLE, size: props.size || 'full-width', style: _ui_1.Dropdown.STYLES.BORDERLESS, options: options, value: options.find((o) => o.value === props.value), placeholder: selectedOpt?.label, hasError: props.hasError, onChange: (opt) => {
            if (opt.value === 'any') {
                props.onChange?.(null);
            }
            else {
                if ((0, util_1.isDefined)(opt.value) && (0, util_1.isNotNull)(opt.value)) {
                    props.onChange?.(opt.value);
                }
            }
        }, disabled: props.disabled }));
};
exports.SkillSelect = SkillSelect;
exports.SkillSelect.defaultProps = {
    includeAny: true,
    disabled: false,
    value: null,
    label: null,
    hasError: false,
    className: '',
    onChange: () => { },
    onClick: () => { },
};
exports.default = exports.SkillSelect;
